const styles = {
  imageStyle: {
    width: "60px",
    height: "60px",
  },
};

export default styles;
